export const Projects = (
  <div className="grid grid-cols-5 gap-2 place-items-start text-sm sm:text-lg">
    <div className="my-0.5 cc-2 col-span-2">
      <p>
        <a
          href="https://github.com/michkz/voidscan"
          target="_blank"
          rel="noreferrer"
        >
          ./<u>voidscan</u>
        </a>
      </p>
    </div>
    <div className="col-span-3">
      <p>
        Voidscan was part of an assignment I did during my first internship at
        Wortell. It's a free and open-source Blackbox Reconnaissance tool that
        gathers information about a given scope and immediately processes the
        results into a clean formatted report. It is created with Python and
        Jinja2, conform the pep8 guidelines
      </p>{" "}
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>
        <a
          href="http://yinyonglim.nl/the-hidden-cost-of-the-internet/"
          target="_blank"
          rel="noreferrer"
        >
          ./<u>the-hidden-cost-of-the-internet</u>
        </a>
      </p>
    </div>
    <div className="col-span-3">
      <p>
        The hidden cost of the internet is a graduation project from a friend of
        mine. On this website you're able to calculate how much CO2 emission you
        produce by using the internet on a monthly basis. The goal was to create
        awareness in a way that's playful so young and old can understand how
        much impact the use of internet has on our climate. I helped him with
        the design and build the website for him in ReactJS.
      </p>
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>./intracloud</p>
    </div>
    <div className="col-span-3">
      <p>
        My last project at the HAN involved building a cloud solution for
        employees and students at the HAN. It features SaaS, PaaS and IaaS
        solutions, build with one orchestrator and with a support system.
      </p>{" "}
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>./securesh</p>
    </div>
    <div className="col-span-3">
      <p>
        SecureSH was a project that focused around multiple services that a
        hosting company could offer with the main focus on security. This
        included a web-, mail- and database server, combined with customer
        support and VPN service of which I mainly worked on the VPN service.
        After building a proof of concept, a test had been conducted and
        reported in the form of an audit report.
      </p>{" "}
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>./cloud7</p>
    </div>
    <div className="col-span-3">
      <p>
        Cloud 7 was a project build for the fictive police department of the
        Netherlands. It features a complete infrastructure with an intra- and
        internet side. The assignment was to communicate with other police
        departments from France, Switzerland and Germany only in a secure way.
        The main goal from the perspective of the study was to show how to build
        an infrastructure with DNS, mail and sharepoint servers all in a
        securely setup environment.
      </p>{" "}
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>./eenmaal-andermaal</p>
    </div>
    <div className="col-span-3">
      <p>
        Eenmaal Andermaal is the first larger group project I had to make at the
        HAN. The goal was to create an auction website where you could sign up
        to post your own auctions similiar to marktplaats and eBay. It was made
        with PHP and a MySQL database.
      </p>
      <br />
    </div>
    <div className="my-0.5 cc-2 col-span-2">
      <p>./fletnix</p>
    </div>
    <div className="col-span-3">
      <p>
        Fletnix was a project I had to do during my Web Development semester at
        the HAN. The idea was to create a website where you can watch movies and
        rate them with a rating system. I've worked with my classmate on this
        project and we went for a minimal/flat type of website
      </p>
      <br />
    </div>
  </div>
);

export default Projects;
